export default __webpack_public_path__ + "static/kb_3_main-f13c95341f2315faa9495c2e14b8c6ea.png";